import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function AccountDataLink() {
  const { t } = useTranslation();
  return <Link to="/account/data" className="inline-block py-2 text-sm text-amber-dark underline">
    {t("account_data.title")}
  </Link>;
}
